import React, { FC } from "react";

import { DataViewKey, FormatType, KpkMedia } from "@keepeek/commons";
import { Box } from "@mui/material";
import clsx from "clsx";

import logger from "../../lib/logger-utils";
import TypeByElement, { DownloadManagerFormatsByElement } from "./TypeByElement";

export type DownloadManagerElementListsProps = {
  loading: boolean;
  formatsByElements: DownloadManagerFormatsByElement[];
  onSelectFormat: (element: KpkMedia["id"], format: FormatType["id"]) => void;
  dataviewkey: DataViewKey;
};

const DownloadManagerElementLists: FC<React.PropsWithChildren<DownloadManagerElementListsProps>> =
  function ({ formatsByElements, onSelectFormat, dataviewkey }) {
    return (
      <Box
        className={clsx("DownloadManagerElementLists")}
        component="ul"
        sx={{
          listStyle: "none",
          padding: 0,
          margin: (theme) => theme.spacing(2, 0),
        }}
      >
        {formatsByElements.map((formatsByElement) => (
          <TypeByElement
            key={formatsByElement.element}
            formatsByElement={formatsByElement}
            onSelectFormat={(format) => onSelectFormat(formatsByElement.element, format)}
            onApplyToAll={(format) => logger.info(`Apply this format to all: ${format}`)}
            dataviewkey={dataviewkey}
          />
        ))}
      </Box>
    );
  };

export default DownloadManagerElementLists;
